// SPDX-License-Identifier: AGPL-3.0-or-later

/** Pure context rule shared by the Web command hook and focused tests. */
export function isBridgeGuildContext(ownerIsBot: boolean, memberBotFlags: ReadonlyArray<boolean>): boolean {
	return ownerIsBot || memberBotFlags.some(Boolean);
}
